module.exports = __webpack_public_path__ + "img/like.e7bc5ecf.svg";